import { createSlice } from '@reduxjs/toolkit';

import { handleLogin } from '~/thunks/auth/authThunk';
import { StoragesEnum } from '~/utils/enum';

export interface AuthState {
  accessToken: string | null | undefined;
  loading: boolean;
}

const initialState: AuthState = {
  accessToken: localStorage.getItem(StoragesEnum.ACCESS_TOKEN)! || null,
  loading: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    handleLogout(state) {
      localStorage.removeItem(StoragesEnum.ACCESS_TOKEN);
      localStorage.removeItem(StoragesEnum.ROLE);
      state.accessToken = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleLogin.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(handleLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.accessToken = action.payload;
        localStorage.setItem(StoragesEnum.ROLE, action.payload?.data?.account?.role);
      })
      .addCase(handleLogin.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const authActions = authSlice.actions;
export const authLoading = (state: any) => state.auth.loading;
export const authAccessToken = (state: any) => state.auth.accessToken;
export const authCurrentUser = (state: any) => state.auth.user;

const authReducer = authSlice.reducer;
export default authReducer;
